module.exports = __webpack_public_path__ + "img/self-m.f240e0ae.png";